module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("\n        " + _vm._s(_vm.theEditSupplementType ? _vm.theEditSupplementType.title : 'Tilføj ny tillægsstype') + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(!_vm.theEditSupplementType) ? [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "title_input",
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Tillægskode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })])] : [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n            Vælg udløbsdato\n          ")]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.endDate,
      "width100": true
    }
  })], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theEditSupplementType && !_vm.isValid) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("\n          Opret\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.theEditSupplementType && _vm.isValid) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          Opret\n        ")]) : _vm._e(), _vm._v(" "), (_vm.theEditSupplementType) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Gem")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ef39ec8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/CreateSupplementstype.vue
// module id = 1731
// module chunks = 1